export enum AddressType {
    NONE = -1,
    Home = 0,
    Office = 1,
    Other = 2,
    Emergency = 3,
    other = '' || undefined || null
}